module.exports = __webpack_public_path__ + "static/media/goodreads.4e97fef5.svg";